import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import ProgressiveImage from 'react-progressive-image';
import './Banner.css';
import banner from './imgs/banner.png';
import banner_low from './imgs/banner_low.jpg';
import banner1 from './imgs/banner1.png';
import banner1_low from './imgs/banner1_low.jpg';
import banner2 from './imgs/banner2.png';
import banner2_low from './imgs/banner2_low.jpg';
import rect from './imgs/rect.svg';

import { Link } from 'react-router-dom';

class Banner extends Component {

  getStyle = (src) => {
    const preview = src.indexOf("low") !== -1;
    const scaleRatio = 1 + 50/window.screen.availWidth;
    return {
      filter: `blur(${preview ? "10px" : "0"})`,
      transform: `scale(${scaleRatio})`,
      transition: `${preview ? "filter" : "none"} 1000ms ease-in-out`,
    };
  };

  render() {
    return (
      <div className="Carousel" >
        <Carousel
          axis="vertical"
          showArrows={false}
          showStatus={false}
          showThumbs={false}
          autoPlay={true}
          interval={3000}
          stopOnHover={false}
          infiniteLoop={true}
        >
          <div>
            <ProgressiveImage src={banner} placeholder={banner_low}>
              {(src) => <img src={src} alt="banner" style={this.getStyle(src)}/>}
            </ProgressiveImage>
          </div>
          <div>
            <ProgressiveImage src={banner1} placeholder={banner1_low}>
              {(src) => <img src={src} alt="banner" style={this.getStyle(src)}/>}
            </ProgressiveImage>
          </div>
          <div>
            <ProgressiveImage src={banner2} placeholder={banner2_low}>
              {(src) => <img src={src} alt="banner" style={this.getStyle(src)}/>}
            </ProgressiveImage>
          </div>
        </Carousel>
        <div className="Text">
          <h2 style={{ fontWeight: 700 }}>Get cashback for every item you buy through <span className="subtitle" style={{ fontWeight: 300 }}>QbatesApp</span></h2>
          <p><img src={rect} alt="Rect"/>Earn up to 20% on everything you buy with the QbatesApp.</p>
          <button><Link to="/login">JOIN FOR FREE</Link></button>
        </div>
      </div>
    );
  }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/Containers/Home/components/Banner.js